import "./AlterDialog.scss";
import { FunctionComponent, ReactNode } from "react";
import { MessageDialogProps } from "./IAlterDialog";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber"; // MUI Warning Icon

const AlterDialog: FunctionComponent<MessageDialogProps> = (props) => {
  const {
    open,
    setOpen,
    alterheading,
    alterableName,
    messageheading,
    messageableName,
    altermessage,
    questioncount,
    questioncountflag,
    listcount,
    listcountflag,
    buttonname,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  // Dynamic heading/message selection
  const heading: ReactNode = messageheading || alterheading || "Warning";
  const mainMessage: ReactNode = messageableName || alterableName || "";
  const secondaryMessage: ReactNode = altermessage || null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      classes={{ paper: "alter_dialog" }}
    >
      {/* Title with Warning Icon */}
      <DialogTitle className="alter_dialog_title">
        <WarningAmberIcon
          sx={{ fontSize: 24, color: "#f59e0b", marginRight: "8px" }}
        />
        {heading}
      </DialogTitle>

      {/* Content */}
      <DialogContent className="alter_dialog_content">
        {mainMessage && (
          <Typography
            sx={{
              fontSize: "14px",
              color: "#374151",
              lineHeight: 1.5,
              textAlign: "center", // center text
            }}
          >
            {mainMessage}
          </Typography>
        )}

        {secondaryMessage && (
          <Typography
            sx={{
              fontSize: "12px",
              color: "#6B7280",
              marginTop: "10px",
              textAlign: "center", // center text
            }}
          >
            {secondaryMessage}
          </Typography>
        )}

        {/* Extra counts */}
        {(questioncount || questioncountflag || listcount || listcountflag) && (
          <div className="alter_counts">
            {questioncount !== undefined && (
              <div>Questions Skipped: {questioncount}</div>
            )}
            {questioncountflag !== undefined && (
              <div>Flagged Questions: {questioncountflag}</div>
            )}
            {listcount !== undefined && (
              <div>Skipped Question Numbers: {listcount}</div>
            )}
            {listcountflag !== undefined && (
              <div>Flagged Question Numbers: {listcountflag}</div>
            )}
          </div>
        )}
      </DialogContent>

      {/* Buttons */}
      <DialogActions className="alter_dialog_action">
        {buttonname ? (
          buttonname
        ) : (
          <>
            <Button onClick={handleClose} className="alter_button">
              Yes
            </Button>
            <Button
              onClick={handleClose}
              variant="outlined"
              className="cancel_button"
            >
              No
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlterDialog;
